import { IResponse, IResponsePagination } from '@/types/common';
import { IGetListCalendarPostResponse } from '@/types/response';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';
import { ICreateCalendarPostRequest, IGetListCalendarPostRequest, IUpdateCalendarPostRequest } from '@/types/request';

class CalendarPost {
  getList = (
    params: IGetListCalendarPostRequest,
  ): Promise<IResponsePagination<IGetListCalendarPostResponse>> => {
    return axiosClient.get(ENDPOINT.CALENDAR_POST.GET_LIST, { params: params });
  };

  delete = (id: number) => {
    return axiosClient.delete(ENDPOINT.CALENDAR_POST.DELETE.replace(':id', String(id)));
  };

  create = (body: ICreateCalendarPostRequest): Promise<IResponse<any>> => {
    return axiosClient.post(ENDPOINT.CALENDAR_POST.CREATE, body);
  };

  getDetail = (id: number): Promise<IResponse<any>> => {
    return axiosClient.get(
      ENDPOINT.CALENDAR_POST.GET_DETAIL.replace(':id', String(id)),
    );
  };

  update = (data: IUpdateCalendarPostRequest, id: number): Promise<IResponse<any>> => {
    return axiosClient.put(
      ENDPOINT.CALENDAR_POST.UPDATE.replace(':id', String(id)),
      data,
    );
  };

}

export const CalendarPostService = new CalendarPost();
